<template>
  <frontoffice-frame>
    <offline-booking-form-edit/>
  </frontoffice-frame>
</template>

<script>
import frontofficeFrame from '@/components/frontoffice/frame'
import OfflineBookingFormEdit from '@/components/frontoffice/OfflineBooking/OfflineBookingFormEdit'

export default {
  components: {
    frontofficeFrame,
    OfflineBookingFormEdit
  }
}
</script>
